<template>
  <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path d="M30.088 17.32a1.453 1.453 0 00-1.435-.088l-3.496 1.516a.335.335 0 00-.197.308v7.221c0 .135.078.256.197.308l3.494 1.516a1.426 1.426 0 001.437-.088c.415-.309.653-.815.632-1.347v-8a1.597 1.597 0 00-.632-1.346zM1.28 16.833a1.5 1.5 0 011.5-1.5h18.76a1.5 1.5 0 011.5 1.5V28.5a1.5 1.5 0 01-1.5 1.5H2.78a1.5 1.5 0 01-1.5-1.5V16.833zM5.76 14c3.181 0 5.76-2.686 5.76-6S8.941 2 5.76 2C2.579 2 0 4.686 0 8s2.579 6 5.76 6zM17.28 14c2.12 0 3.84-1.79 3.84-4s-1.72-4-3.84-4-3.84 1.79-3.84 4 1.72 4 3.84 4z" fill="#fff"/>
  </svg>
</template>

<script>
  export default {
    name: 'VideosIcon'
  }
</script>
